<template>
    <b-modal title="Informações do Fornecedor" v-model="show" size="lg">
      <b-container fluid>
        <b-row class="mt-2">
          <b-col cols="11">
            <b-form-group label="Nome:" label-for="nome" label-cols-sm="3" label-align-sm="right">
              <b-form-input id="nome" v-model="editing.nome" />
            </b-form-group>
          </b-col>
        </b-row>
  
        <b-row>
          <b-col cols="11">
            <b-form-group label="CNPJ:" label-for="cnpj" label-cols-sm="3" label-align-sm="right"
              ><b-form-input id="cnpj" v-model="editing.cnpj" v-mask="'##.###.###/####-##'" />
            </b-form-group>
          </b-col>
        </b-row>
  
        <b-row>
          <b-col cols="11">
            <b-form-group
              label="Endereço:"
              label-for="endereco"
              label-cols-sm="3"
              label-align-sm="right"
              ><b-form-input id="endereco" v-model="editing.endereco" />
            </b-form-group>
          </b-col>
        </b-row>
  
        <b-row>
          <b-col cols="11">
            <b-form-group label="Bairro:" label-for="bairro" label-cols-sm="3" label-align-sm="right"
              ><b-form-input id="bairro" v-model="editing.bairro" />
            </b-form-group>
          </b-col>
        </b-row>
  
        <b-row>
          <b-col cols="11">
            <b-form-group label="Cidade:" label-for="cidade" label-cols-sm="3" label-align-sm="right"
              ><b-form-input id="cidade" v-model="editing.cidade" />
            </b-form-group>
          </b-col>
        </b-row>
  
        <b-row>
          <b-col cols="11">
            <b-form-group label="UF:" label-for="uf" label-cols-sm="3" label-align-sm="right"
              ><b-form-select id="uf" v-model="editing.uf" :options="estados.brasil" />
            </b-form-group>
          </b-col>
        </b-row>
  
        <b-row>
          <b-col cols="11">
            <b-form-group
              label="Telefone:"
              label-for="telefone"
              label-cols-sm="3"
              label-align-sm="right"
              ><b-form-input
                id="telefone"
                v-model="editing.telefone"
                v-mask="['(##) ####-####', '(##) #####-####']"
              />
            </b-form-group>
          </b-col>
        </b-row>
  
        <b-row>
          <b-col cols="11">
            <b-form-group label="E-mail:" label-for="email" label-cols-sm="3" label-align-sm="right"
              ><b-form-input id="email" v-model="editing.email" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>
  
      <template #modal-footer>
        <b-button variant="primary" @click="salvar()">Salvar</b-button>
        <b-button variant="secondary" @click="show = !show">Fechar</b-button>
      </template>
    </b-modal>
  </template>
  
  <script>
  import { useSgcqStore } from "@/stores/SgcqStore";
  import { useFornecedorStore } from "@/stores/FornecedorStore";
  import Fornecedor from "@/models/Fornecedor";
  import EstadosUF from "@/tools/EstadosUF";
  import Notificacao from "@/models/Notificacao";
  
  export default {
    name: "ModalDeEdicaoDeFornecedor",
  
    data() {
      return {
        show: false,
        editing: new Fornecedor(0, "", "", "", "", "", "", "", ""),
        estados: new EstadosUF(),
      };
    },
  
    methods: {
      salvar() {
        if (this.editing.id != 0) {
          this.fornecedorStore.ALTERAR_FORNECEDOR(this.editing).then(() => {
            this.store.NOTIFICAR(
              new Notificacao("Fornecedor salvo no SGCQ com sucesso!", "Excelente!", "success")
            );
          });
        } else {
          this.fornecedorStore
            .CADASTRAR_FORNECEDOR(this.editing)
            .then(() =>
              this.store.NOTIFICAR(
                new Notificacao("Fornecedor salvo no SGCQ com sucesso!", "Excelente!", "success")
              )
            );
        }
        this.show = !this.show;
      },
  
      call(fornecedor) {
        this.show = !this.show;
        this.editing = fornecedor;
      },
    },
  
    setup() {
      const store = useSgcqStore();
      const fornecedorStore = useFornecedorStore();
  
      return {
        store,
        fornecedorStore,
      };
    },
  };
  </script>
  
  <style lang="scss" scoped></style>